import { createFormDataRequest } from "@/helpers/FormHelpers";
import CompanyUser, { CompanyUserFilters } from "@/interfaces/CompanyUser";
import { IPaginateResponse } from "@/interfaces/Fetch";
import Note from "@/interfaces/Note";
import api from "../api";

export const userCompaniesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserCompanies: build.query<
      IPaginateResponse<CompanyUser>,
      [string, CompanyUserFilters]
    >({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/users/${id}/companies`,
          params,
        };
      },
      providesTags: (result, _error, [userId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "UserCompanies" as const,
                userId,
                id,
              })),
              { type: "UserCompanies", userId, id: "LIST" },
            ]
          : [],
    }),
    deleteUserCompany: build.mutation<void, [string, string]>({
      query: ([userId, companyId]) => ({
        url: `/users/${userId}/companies/${companyId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [userId]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "UserCompanies", userId, id: "LIST" },
      ],
    }),
    unDispatchUserCompanies: build.mutation<
      { message: string; deletedCount: number },
      { userId: string; statusIds: string[] }
    >({
      query: ({ userId, statusIds }) => ({
        url: `/users/${userId}/companies/undispatch`,
        method: "POST",
        body: { statusIds },
      }),
      invalidatesTags: (_result, _error, { userId }) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "UserCompanies", userId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetUserCompaniesQuery,
  useDeleteUserCompanyMutation,
  useUnDispatchUserCompaniesMutation,
} = userCompaniesApi;
